/**
 * Abbreviates a team name for the scoreboard. Same rule as the mobile app and
 * the Pixellot overlay's scorebug (pixellot-overlay/src/utils/parseGameConfig.ts):
 * - "Alabama State" → "AS"
 * - "Yale" → "YA"
 * - "Smith College" → "SC"
 */
export const abbreviateTeamName = (name: string) => {
  // Extra whitespace would leave empty words with no first letter
  const parts = name.trim().split(/\s+/);
  if (parts.length > 1) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return parts[0].slice(0, 2).toUpperCase();
};
